function initVuduContactMaps() {
  if (typeof L === 'undefined') {
    setTimeout(initVuduContactMaps, 100);
    return;
  }

  var mapElements = document.querySelectorAll('[id^="vudu-contact-map-"]');

  mapElements.forEach(function (el) {
    if (!el || el.dataset.initialized) return;
    el.dataset.initialized = 'true';

    var lat = parseFloat(el.dataset.lat) || 54.5833;
    var lng = parseFloat(el.dataset.lng) || -5.55;
    var zoom = parseInt(el.dataset.zoom) || 11;
    var googleMapsUrl = el.dataset.googleMapsUrl || '';

    var map = L.map(el.id, {
      scrollWheelZoom: false,
    }).setView([lat, lng], zoom);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 19,
    }).addTo(map);

    var outerMarker = L.circleMarker([lat, lng], {
      radius: 20,
      fillColor: 'transparent',
      fillOpacity: 0,
      color: '#172C93',
      weight: 2,
    }).addTo(map);

    var innerMarker = L.circleMarker([lat, lng], {
      radius: 13,
      fillColor: '#172C93',
      fillOpacity: 1,
      color: '#172C93',
      weight: 0,
    }).addTo(map);

    if (googleMapsUrl) {
      function openGoogleMaps() {
        window.open(googleMapsUrl, '_blank');
      }
      outerMarker.on('click', openGoogleMaps);
      innerMarker.on('click', openGoogleMaps);
      outerMarker.getElement().style.cursor = 'pointer';
      innerMarker.getElement().style.cursor = 'pointer';
    }
  });
}

document.addEventListener('DOMContentLoaded', initVuduContactMaps);